import {
  GlobalModalContext,
  type GlobalModalContextValue,
} from './GlobalModalContext.js';
import { useContext } from 'react';

export const useGlobalModalContext = (): GlobalModalContextValue => {
  const context = useContext(GlobalModalContext);

  if (!context) {
    throw new Error(
      'useGlobalModalContext was not called within a GlobalModalProvider.',
    );
  }

  return context;
};
